import { useMemo } from "react"

import { useProductConfigurationModelsQuery } from "entities/dim-configuration/graphql/product-configuration.queries.generated"

/**
 * Hook to check if a product configuration model is available for a given product type
 * @param productType - The product type to check for configuration availability
 * @returns Object containing availability status and loading state
 */
export function useProductConfigurationModelAvailability(
  productType: string | null | undefined
) {
  const { data: productConfigurationModelsData, loading: isLoadingModels } =
    useProductConfigurationModelsQuery()

  const isConfigurationAvailable = useMemo(() => {
    if (isLoadingModels || !productConfigurationModelsData) return false
    return (
      productConfigurationModelsData.configurationModels?.models?.some(
        model => model?.id === productType
      ) ?? false
    )
  }, [productConfigurationModelsData, productType, isLoadingModels])

  return {
    isConfigurationAvailable,
    isLoading: isLoadingModels,
    data: productConfigurationModelsData
  }
}
